<template>
  <div
    v-show="modalStatus"
    class="pdf-view-v2"
  >
    <div
      class="pdf-view-v2__overlay"
      @click="closeModal"
    />
    <div class="pdf-view-v2__modal">
      <button
        class="btn-close"
        @click="closeModal"
      >
        <svg-loader src="/static/images/icon-close-small.svg" />
      </button>
      <iframe
        ref="iframe"
        width="100%"
        height="100%"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PdfViewV2',
  props: {
    content: {
      type: Uint8Array,
      required: true
    }
  },
  data() {
    return {
      modalStatus: false
    }
  },
  watch: {
    content(newValue) {
      if (newValue && newValue.length > 0) {
        const blob = new Blob([newValue], { type: 'application/pdf' })
        const url = URL.createObjectURL(blob)
        this.$refs.iframe.src = url
        this.modalStatus = true
      }
    }
  },
  methods: {
    closeModal() {
      this.$refs.iframe.src = ''
      this.modalStatus = false
    }
  }
}
</script>

<style lang="scss" scoped>
.pdf-view-v2 {
  &__modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    max-width: 1000px;
    width: 90%;
    height: 100%;
    overflow: hidden;
    padding: 20px 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    z-index: 1000;
    border-radius: 8px;

    iframe {
      height: 100%;
      border: none;
      margin: 40px 0;
    }

    .btn-close {
      position: absolute;
      top: 12px;
      right: 30px;
      background: transparent;
      color: #000;
    }
  }

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
}
</style>
